import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import BCircuitos from "./BCircuitos"
import BEditar from './BEditar'
import BHotel from './BHoteles'
import BPlaza from './Bplaza'
import BExtras from './BExtras'
import BCiudades from './BCiudades'
import BImagenes from './BImagenes'
import BMayorista from './BMayorista'

import { makeStyles } from '@material-ui/core/styles'
import { formatDinero } from '../../../utils/formatDinero'
import { useDispatch, useSelector } from 'react-redux'
import { offLoadAction, onLoadAnction } from '../../../ducks/loadDuck'
import { obtenerTerrestrePaginaAction, obtenerTerrestreRegistrosAction } from '../../../ducks/proveedorTerrestreDuck'
import { obtenerPaqueteMayoristaPaginaDetalleAction, obtenerPaqueteMayoristaRegistrosDetalleAction } from '../../../ducks/proveedorMayoristaDuck'

const columns = [
  // { id: "1", minWidth: 150, align: "center", label: 'Clave' },
  { id: "2", minWidth: 150, align: "center", label: 'Nombre' },
  { id: "3", minWidth: 150, align: "center", label: 'Precio neto' },
  { id: "4", minWidth: 150, align: "center", label: 'Proveedor' },
  { id: "5", minWidth: 150, align: "center", label: '' },
]

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
})

export default function TProveedoresTerrestres() {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { totalArrayTerrestre, regisitros, pagina } = useSelector(store => store.proveedorTerrestre)
  const { listaCircuitosDetalle } = useSelector(store => store.proveedorMayorista);

  const rows = listaCircuitosDetalle ?? []

  const handleChangePage = (event, newPage) => {
    dispatch(onLoadAnction({message: ""}))
    dispatch(obtenerTerrestrePaginaAction({ pagina: newPage})).then(Response => {
      dispatch(offLoadAction())
    })

    dispatch(obtenerPaqueteMayoristaPaginaDetalleAction({ pagina: newPage })).then(Response => {
      dispatch(offLoadAction())
    })
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch(onLoadAnction({message: ""}))
    dispatch(obtenerTerrestreRegistrosAction({regisitros: +event.target.value})).then(Response => {
      dispatch(offLoadAction())
    })

    dispatch(obtenerPaqueteMayoristaRegistrosDetalleAction({ registros: +event.target.value })).then(Response => {
      dispatch(offLoadAction())
    })
  }
  
  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          
          <TableBody>
            {rows.map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.IdPaqueteProveedorTerrestre}>
                  {/* <TableCell align='center'>
                    {`${row.ClavePaquete}`}
                  </TableCell> */}
                  <TableCell align="center">{row.Nombre}</TableCell>
                  <TableCell align="center">{`${formatDinero(row.PrecioNeto)} ${row?.Moneda?.Clave}`}</TableCell>
                  <TableCell align='center'>{row?.Proveedor?.RazonSocial}</TableCell>
                  <TableCell>
                    <BCircuitos idProveedor={row.IdPaqueteProveedorTerrestre} clavePaquete={row.ClavePaquete} paquete={row} />
                    <BEditar paquete={row} />
                    <BHotel paquete={row} />
                    <BPlaza paquete={row} />
                    <BExtras paquete={row} />
                    <BCiudades paquete={row} />
                    <BMayorista paquete={row} />
                    <BImagenes paquete={row} />
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalArrayTerrestre}
        rowsPerPage={regisitros}
        page={pagina}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  )
}